// PromoBanner.jsx
import React from "react";

const PromoBanner = ({ banner }) => {
  // If a banner URL was passed in, render it as an <img>
  if (banner) {
    return <img className="form-banner" src={banner} alt="Promotional banner" />;
  }

  // Otherwise, render your original text-based div
  return (
    <div className="promo-banner">
      <p>Save 10% on your subscription for the year!</p>
    </div>
  );
};

export default PromoBanner;
